import { FeatureFlagService, FeatureFlag } from '../../omnibox/services/FeatureFlagService';
import {getSessionManagementServiceInstance,} from '../../omnibox/services/SessionManagementService';

export namespace CollectionUtils {
  /*
  If collectionsSiteSetting FF is On:
  check to see site settings value to enable collections
  If collectionsSiteSetting FF is Off:
  enable collections.
  */
  export const checkCollectionSiteSetting: () => (boolean) = () => {
    const isCollectionsEnabled = getSessionManagementServiceInstance().isCollectionsEnabledOnSite();
    return FeatureFlagService.instance.getValue(FeatureFlag.collectionsSiteSetting) ? isCollectionsEnabled : true;
  };
}